/**
 * Componente que muestra de forma compacta al empleado responsable.
 * * **Funcionalidades**:
 * - Renderiza un estado "Sin responsable" si no se proporciona un objeto de empleado.
 * - Muestra la fotografía del empleado si está disponible; de lo contrario, genera un avatar con iniciales.
 * - Maneja el truncado de texto para nombres largos para evitar desbordamientos visuales.
 * * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} [props.employee] - Objeto con la información del empleado.
 * @param {string} props.employee.nombre - Nombre del empleado.
 * @param {string} [props.employee.apellido] - Apellido del empleado.
 * @param {string} [props.employee.photo] - URL de la imagen de perfil del empleado.
 * * @returns {JSX.Element} Avatar pequeño con el nombre del responsable.
 */
const ResponsibleCard = ({ employee }) => {
  /**
   * Genera las iniciales del empleado basándose en su nombre y apellido.
   * @returns {string} Las iniciales en mayúsculas (ej: "JD") o "?" si no hay datos.
   */
  const getInitials = () => {
    if (!employee?.nombre) return '?'
    return `${employee.nombre[0]}${employee.apellido?.[0] || ''}`.toUpperCase()
  }

  // Si no hay empleado asignado todavía
  if (!employee) {
    return (
      <div className="vt-person is-empty">
        <span className="vt-avatar">
          <i className="fa-solid fa-user" />
        </span>
        <span className="vt-person-name">Sin responsable</span>
      </div>
    )
  }

  return (
    <div className="vt-person">
      <span className="vt-avatar">
        {employee.photo ? (
          <img src={employee.photo} alt={employee.nombre} />
        ) : (
          getInitials()
        )}
      </span>
      <span className="vt-person-name" title={employee.nombre}>
        {`${employee.nombre} ${employee.apellido || ''}`}
      </span>
    </div>
  )
}

export default ResponsibleCard
